import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { ReportData } from 'src/shared/models/report-data.model';
import { ReportFilters } from 'src/shared/models/report-filters.model';
import { MiscUtil } from 'src/shared/utilities/misc.util';
import { Constants } from 'src/shared/utilities/constants.util';
import { ReportService } from 'src/shared/services/report.service';
import { ReportConstants } from '../../shared/report-constants.util';

@Component({
  selector: 'total-uos-performance-page',
  templateUrl: './total-uos-performance-page.component.html',
  styleUrls: ['./total-uos-performance-page.component.scss']
})
export class TotalUosPerformancePageComponent implements OnInit {
  performanceData :ReportData;
  filterEventsSubject: Subject<void> = new Subject<void>();
  filters:ReportFilters;
  defaultFilters: ReportFilters;
  views:string[];
  showDailyChurn:boolean;

  constructor(private reportService: ReportService){
  }
  
  ngOnInit() {
    this.performanceData = new ReportData();
    this.filters = new ReportFilters();
    this.defaultFilters = new ReportFilters();
    this.filters = new ReportFilters();
    this.views = [ 
        ReportConstants.DateViewLabel,
        ReportConstants.DayOfWeekViewLabel, 
        ReportConstants.PeriodEndViewLabel, 
        ReportConstants.ShiftBlockViewLabel, 
        ReportConstants.WeekViewLabel
    ];
    this.reportService.announceSummarySelected(Constants.TotalUosSummary);
  }

  performanceDataUpdated(reportData: ReportData) {
      this.showDailyChurn = this.filters.ReportView == ReportConstants.DayOfWeekViewLabel;
      this.performanceData = reportData;
  }

  filterUpdated(filters:ReportFilters) {
      this.filters = filters;
      this.filterEventsSubject.next();
  }
  formatValue(value:number, decimalPlaces = 2) {
    return MiscUtil.formatGridValue(value, decimalPlaces);
  }

}
